function IconCoder() {
  return (
    <svg
      className="w-full h-full"
      width="500"
      height="500"
      viewBox="0 0 173 139"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M162.166 2.7793H10.1821C5.75937 2.7793 2.17407 2.78383 2.17407 2.78383V136.779H10.1821H162.166H170.174V2.78306C170.174 2.78306 166.589 2.7793 162.166 2.7793Z"
        fill="#C4C4C4"
      />
      <path
        d="M162.166 2.78134H10.1821C5.75942 2.78134 2.17407 2.7793 2.17407 2.7793L2.17423 136.781H170.174V2.78403C170.174 2.78122 167.463 2.78126 163.847 2.78132L162.166 2.78134Z"
        stroke="#C4C4C4"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.507 12.9062C12.2328 12.9062 13.632 11.5071 13.632 9.78125C13.632 8.05536 12.2328 6.65625 10.507 6.65625C8.78107 6.65625 7.38196 8.05536 7.38196 9.78125C7.38196 11.5071 8.78107 12.9062 10.507 12.9062Z"
        fill="#FF5F5A"
      />
      <path
        d="M20.34 12.9062C22.0659 12.9062 23.465 11.5071 23.465 9.78125C23.465 8.05536 22.0659 6.65625 20.34 6.65625C18.6141 6.65625 17.215 8.05536 17.215 9.78125C17.215 11.5071 18.6141 12.9062 20.34 12.9062Z"
        fill="#FFBE2E"
      />
      <path
        d="M29.6741 12.9062C31.4 12.9062 32.7991 11.5071 32.7991 9.78125C32.7991 8.05536 31.4 6.65625 29.6741 6.65625C27.9482 6.65625 26.5491 8.05536 26.5491 9.78125C26.5491 11.5071 27.9482 12.9062 29.6741 12.9062Z"
        fill="#2ACA44"
      />
      <path
        d="M10.007 29.7812H21.007"
        stroke="#46BB86"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.007 29.7812H57.007"
        stroke="#46BB86"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M10.007 37.7812H55.007"
        stroke="#389ABE"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.007 45.7812H41.007"
        stroke="#E5C689"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.007 45.7812H71.007"
        stroke="#696F7A"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.007 53.7812H77.007"
        stroke="#696F7A"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.007 61.7812H65.007"
        stroke="#FFA49F"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.007 69.7812H69.007"
        stroke="#696F7A"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M10.007 76.7812H37.007"
        stroke="#389ABE"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  )
}
export default IconCoder
